var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PaymentAdapter, PaymentVendors } from '../Interfaces/interface.adapter.js';
import { PaymentErrorShortCodes } from '../Interfaces/index.js';
import { Base64 } from 'js-base64';
import { PaymentClientError } from '../index.js';
var PaymentAdapterDummy = /** @class */ (function (_super) {
    __extends(PaymentAdapterDummy, _super);
    function PaymentAdapterDummy(env, vendorSessionInfo, billingContactInfo) {
        var _this = _super.call(this) || this;
        _this.vendorName = PaymentVendors.dummy;
        _this.threeDSecurePayload = {};
        _this.env = env;
        _this.vendorSessionInfo = vendorSessionInfo;
        _this.billingContactInfo = billingContactInfo;
        return _this;
    }
    Object.defineProperty(PaymentAdapterDummy.prototype, "threeDSPayload", {
        set: function (payload) {
            if (!payload) {
                throw new PaymentClientError('Invalid 3DS payload', PaymentErrorShortCodes.invalid_3ds_payload);
            }
            this.threeDSecurePayload = payload;
        },
        enumerable: false,
        configurable: true
    });
    PaymentAdapterDummy.prototype.encryptCreditCardData = function (creditCard) {
        return __awaiter(this, void 0, void 0, function () {
            var encryptedCard;
            return __generator(this, function (_a) {
                encryptedCard = Base64.encode(creditCard.number);
                return [2 /*return*/, encryptedCard];
            });
        });
    };
    PaymentAdapterDummy.prototype.encryptACHData = function (achInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var data, encryptedACH;
            return __generator(this, function (_a) {
                data = achInfo.bankAccountNumber + '-' + achInfo.bankRoutingNumber;
                encryptedACH = Base64.encode(data);
                return [2 /*return*/, encryptedACH];
            });
        });
    };
    PaymentAdapterDummy.prototype.initializeWebDropIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
            });
        });
    };
    PaymentAdapterDummy.prototype.initializeWebComponent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
            });
        });
    };
    PaymentAdapterDummy.prototype.formatThreeDSecurePayload = function () {
        throw new Error('formatThreeDSecurePayload is not supported with Adyen integration');
    };
    return PaymentAdapterDummy;
}(PaymentAdapter));
export { PaymentAdapterDummy };
